import { render, staticRenderFns } from "./SigInputTexte.vue?vue&type=template&id=6a0d09a8"
import script from "./SigInputTexte.vue?vue&type=script&lang=ts"
export * from "./SigInputTexte.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports